import React from "react";
import dayjs from "dayjs";
import "dayjs/locale/id";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import Edit from "../action/Edit";
import Hapus from "../action/Hapus";

import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";

dayjs.locale("id");

const JENIS = {
  masuk: { label: "Masuk", className: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  keluar: { label: "Distribusi", className: "bg-blue-100 text-blue-800 border-blue-200" },
  rusak: { label: "Rusak", className: "bg-rose-100 text-rose-800 border-rose-200" },
  opname: { label: "Opname", className: "bg-amber-100 text-amber-800 border-amber-200" },
};

function DataStockCard({ rows, handleDelete, handleEdit, loading = false }) {
  const barangTemplate = (row) => (
    <div>
      <p className="m-0 text-sm font-semibold text-gray-900">{row.nama || "-"}</p>
      <p className="m-0 text-xs text-gray-500">{row.kode || "-"}</p>
    </div>
  );

  const jenisTemplate = (row) => {
    const jenis = JENIS[row.jenis] || {
      label: row.jenis || "-",
      className: "bg-gray-100 text-gray-800 border-gray-200",
    };
    return (
      <span className={`rounded-full border px-2 py-1 text-xs font-medium ${jenis.className}`}>
        {jenis.label}
      </span>
    );
  };

  const jumlahTemplate = (row) => {
    const satuan = row.satuan || "";
    if (row.jenis === "opname") return `selisih ${row.jumlah ?? 0} ${satuan}`.trim();
    return `${row.jumlah ?? 0} ${satuan}`.trim();
  };

  const aksiTemplate = (row) => (
    <div className="flex items-center justify-center gap-2">
      <Edit id={row.id} handleEdit={handleEdit} />
      <Hapus id={row.id} handleDelete={handleDelete} />
    </div>
  );

  if (loading) {
    return (
      <div className="flex h-72 items-center justify-center">
        <div className="text-center">
          <div className="mx-auto mb-2 h-8 w-8 animate-spin rounded-full border-b-2 border-primary" />
          <p className="text-gray-600">Memuat kartu persediaan...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full">
      <DataTable
        value={rows}
        paginator
        rows={10}
        rowsPerPageOptions={[5, 10, 25, 50]}
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
        emptyMessage="Belum ada mutasi kartu persediaan"
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        className="p-datatable-sm"
      >
        <Column
          field="tanggal"
          header="Tanggal"
          body={(row) => (row.tanggal ? dayjs(row.tanggal).format("DD MMM YYYY") : "-")}
          style={{ minWidth: "120px" }}
          sortable
        />
        <Column header="Barang" body={barangTemplate} style={{ minWidth: "180px" }} />
        <Column field="jenis" header="Jenis" body={jenisTemplate} style={{ minWidth: "120px" }} sortable />
        <Column header="Jumlah" body={jumlahTemplate} style={{ minWidth: "120px" }} />
        <Column
          header="Sisa"
          body={(row) => `${row.stok_sesudah ?? "-"} ${row.satuan || ""}`.trim()}
          style={{ minWidth: "100px" }}
        />
        <Column field="ruangan" header="Ruangan" body={(row) => row.ruangan || "-"} style={{ minWidth: "140px" }} />
        <Column field="keterangan" header="Keterangan" body={(row) => row.keterangan || "-"} style={{ minWidth: "160px" }} />
        <Column header="Aksi" body={aksiTemplate} style={{ minWidth: "100px", textAlign: "center" }} />
      </DataTable>
    </div>
  );
}

export default DataStockCard;
